import { validateToken, redirectToLogin } from '../../../utils/auth/tokenValidation';

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

type Dispatch = (action: Action) => void;

const API_URL = process.env.REACT_APP_API_URL;

export const DASHBOARD_START = 'DASHBOARD_START';
export const DASHBOARD_STATUS_COUNTS = 'DASHBOARD_STATUS_COUNTS';
export const DASHBOARD_WINNERS_COUNT = 'DASHBOARD_WINNERS_COUNT';
export const DASHBOARD_PRIZE_AMOUNT = 'DASHBOARD_PRIZE_AMOUNT';
export const DASHBOARD_CHANNEL_COUNTS = 'DASHBOARD_CHANNEL_COUNTS';
export const DASHBOARD_END = 'DASHBOARD_END';

export const getCampaignStatusCounts = (payload: { fromDate?: string; toDate?: string; statuses?: string[] }) =>
  async (dispatch: Dispatch): Promise<any> => {
    if (!validateToken()) { redirectToLogin(); return { success: false }; }
    try {
      dispatch({ type: DASHBOARD_START, loading: true });
      const token = localStorage.getItem('loginToken');
      if (!token) throw new Error('Authorization token not found');

      const response = await fetch(`${API_URL}/campaign/get-status-counts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
      const res = await response.json();
      if (response.ok) {
        dispatch({ type: DASHBOARD_STATUS_COUNTS, payload: res, loading: false });
        return { success: true, data: res };
      } else {
        dispatch({ type: DASHBOARD_END, loading: false });
        return { success: false, ...res };
      }
    } catch (error: any) {
      dispatch({ type: DASHBOARD_END, loading: false });
      return { success: false, message: error.message };
    }
  };

export const getAnnouncedWinnersCount = (payload: { fromDate?: string; toDate?: string; statuses?: string[] }) =>
  async (dispatch: Dispatch): Promise<any> => {
    if (!validateToken()) { redirectToLogin(); return { success: false }; }
    try {
      dispatch({ type: DASHBOARD_START, loading: true });
      const token = localStorage.getItem('loginToken');
      if (!token) throw new Error('Authorization token not found');

      const response = await fetch(`${API_URL}/campaign/get-announced-winners-count`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
      const res = await response.json();
      if (response.ok) {
        dispatch({ type: DASHBOARD_WINNERS_COUNT, payload: res, loading: false });
        return { success: true, data: res };
      } else {
        dispatch({ type: DASHBOARD_END, loading: false });
        return { success: false, ...res };
      }
    } catch (error: any) {
      dispatch({ type: DASHBOARD_END, loading: false });
      return { success: false, message: error.message };
    }
  };

export const getTotalPrizeAmount = (payload: { fromDate?: string; toDate?: string }) =>
  async (dispatch: Dispatch): Promise<any> => {
    if (!validateToken()) { redirectToLogin(); return { success: false }; }
    try {
      dispatch({ type: DASHBOARD_START, loading: true });
      const token = localStorage.getItem('loginToken');
      if (!token) throw new Error('Authorization token not found');

      const response = await fetch(`${API_URL}/campaign-winners/get-total-prize-amount`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
      const res = await response.json();
      if (response.ok) {
        dispatch({ type: DASHBOARD_PRIZE_AMOUNT, payload: res, loading: false });
        return { success: true, data: res };
      } else {
        dispatch({ type: DASHBOARD_END, loading: false });
        return { success: false, ...res };
      }
    } catch (error: any) {
      dispatch({ type: DASHBOARD_END, loading: false });
      return { success: false, message: error.message };
    }
  };

export const getTransactionChannelCounts = () =>
  async (dispatch: Dispatch): Promise<any> => {
    if (!validateToken()) { redirectToLogin(); return { success: false }; }
    try {
      dispatch({ type: DASHBOARD_START, loading: true });
      const token = localStorage.getItem('loginToken');
      if (!token) throw new Error('Authorization token not found');

      const response = await fetch(`${API_URL}/api/trx/get-transaction-channel-counts`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      });
      const res = await response.json();
      if (response.ok) {
        dispatch({ type: DASHBOARD_CHANNEL_COUNTS, payload: res, loading: false });
        return { success: true, data: res };
      } else {
        dispatch({ type: DASHBOARD_END, loading: false });
        return { success: false, ...res };
      }
    } catch (error: any) {
      dispatch({ type: DASHBOARD_END, loading: false });
      return { success: false, message: error.message };
    }
  };
